import React from 'react';

const LoadingIndicator = ({ isLoading = true, message = 'Loading...' }) => {
  if (!isLoading) return null;
  
  return (
    <div className="loader-container">
      <div className="loader-message">
        <img src="/ajax-loading.gif" alt="Loading..." style={{ width: '64px', height: '64px' }} />
      </div>
    </div>
  );
};

export default LoadingIndicator;